export const COLORS = [
  "#f8b24f", "#2ecc71", "#3498db", "#e74c3c", "#f1c40f", "#ecf0f1", "#95a5a6",  "#34495e", "#9b59b6", "#16a085",
];

export const BILLABLE_COLORS = ["#2ecc71", "#e74c3c"]

export default COLORS;
